module.exports = "/images/Icon goals-Display Popup Offers & Alerts_1 1.svg?ca4b285d2912ed80a6820cb56f4c6661";